<app-layout>
  <div class="page-not-found">
    <h1>404</h1>
    <div>
      <section>
        <p>Ops!</p>
        <p>A página que você está procurando não pôde ser encontrada.</p>
      </section>
      <app-button (click)="goToHome()" [style]="'max-width:400px;'" icon="pi pi-home"
        >Voltar para a Página Inicial</app-button
      >
    </div>
  </div>
</app-layout>
